// const API_BASE_URL = 'https://server.tradebid.click';
const API_BASE_URL = 'https://server.coinexchangein.store';

export { API_BASE_URL };